<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div id="CYB_PC_CS_02_02" class="modal type-mo-full" data-popup>
        <div class="dialog type-xlarge">
          <header class="dialog-header">
            <h2 class="dialog-title only-pc">주문건 선택</h2>
            <button
              type="button"
              class="dialog-close"
              data-popup-close
              @click="() => emits('close')"
            >
              <span class="c-icon icon-large-x"></span>
              <span class="sr-only">팝업 닫기</span>
            </button>
          </header>

          <div class="dialog-content">
            <div class="dialog-content-inner">
              <!-- D: MO에서만 존재 -->
              <h3 class="c-title-level3 only-mo">주문건 선택</h3>
              <!-- // D: MO에서만 존재 -->
              <div class="order-selection-wrap">
                <!-- D: 기간설정 -->
                <div class="c-filter-box">
                  <strong class="title">구매기간</strong>
                  <!-- D: PC 전용 -->
                  <div class="c-form-field only-pc">
                    <label class="c-input-calender">
                      <input
                        type="text"
                        required=""
                        title="시작일"
                        data-datepicker
                        ref="startDatepickerRef"
                        v-model="data.search.startRegDt"
                        readonly
                      />
                    </label>
                    <span class="tilde">~</span>
                    <label class="c-input-calender">
                      <input
                        type="text"
                        required=""
                        title="종료일"
                        data-datepicker
                        ref="endDatepickerRef"
                        v-model="data.search.endRegDt"
                        readonly
                      />
                    </label>
                  </div>
                  <!-- // D: PC 전용 -->

                  <div class="c-round-button-box">
                    <div class="c-radio-round type-black">
                      <input
                        type="radio"
                        id="filter-date-option6-1"
                        name="filter-date-option6"
                        @change="dateCalculation('1W')"
                        value="1W"
                        v-model="data.check.chkDate"
                      />
                      <label for="filter-date-option6-1">1주일</label>
                    </div>
                    <div class="c-radio-round type-black">
                      <input
                        type="radio"
                        id="filter-date-option6-2"
                        name="filter-date-option6"
                        @change="dateCalculation('1M')"
                        value="1M"
                        v-model="data.check.chkDate"
                        checked
                      />
                      <label for="filter-date-option6-2">1개월</label>
                    </div>
                    <div class="c-radio-round type-black">
                      <input
                        type="radio"
                        id="filter-date-option6-3"
                        name="filter-date-option6"
                        @change="dateCalculation('3M')"
                        value="3M"
                        v-model="data.check.chkDate"
                      />
                      <label for="filter-date-option6-3">3개월</label>
                    </div>
                  </div>

                  <!-- D: PC 전용 -->
                  <div class="c-btn-area">
                    <button
                      type="button"
                      class="c-util-button type-line-black"
                      @click="btnCmd('reset')"
                    >
                      <span>초기화</span>
                    </button>
                    <button
                      type="button"
                      class="c-util-button type-primary"
                      @click="searchCmd('search')"
                    >
                      <span>조회</span>
                    </button>
                  </div>
                  <!-- // D: PC 전용 -->
                </div>

                <!-- D: 조회한 주문건 노출(데이터 없는경우 숨김) -->
                <div class="c-search-result-keyword">
                  <p class="text">
                    총
                    <b class="color-primary">{{ data.one.totalCount }}</b
                    >개
                  </p>
                </div>
                <!-- // D: 조회한 주문건 노출(데이터 없는경우 숨김) -->

                <!-- D: 주문건 선택리스트 -->
                <div
                  class="c-accordion-list type-selected"
                  data-accordion-wrap
                  v-if="data.one.list.length > 0"
                >
                  <ul>
                    <li v-for="(item, idx) in data.one.list" :key="idx">
                      <!--
                  D: 아코디언
                  1. 클릭시(활성화) aria-expanded true 나머지 형제들 false
                  3. 클릭시 accordion-content에 aria-hiddne="false"로 값을 변경해주셔야 콘텐츠 나옵니다
                -->
                      <div
                        class="accordion-button"
                        data-accordion-trigger
                        :aria-expanded="data.one.expendIndex === idx"
                        :aria-controls="'act' + idx"
                        @click="btnCmd('expendClick', { index: idx })"
                      >
                        <div class="c-radio type-selected">
                          <div style="display: none">
                            {{ item.orderSn }} :::: {{ data.check.orderChek }}
                          </div>
                          <input
                            type="radio"
                            :id="'order-radio-' + idx"
                            name="order-radio"
                            :value="item.orderSn"
                            v-model="data.check.orderChek"
                            @click="
                              btnCmd('orderChk', {
                                list: item.detail,
                                index: idx,
                                title: item,
                              })
                            "
                          />
                          <label :for="'order-radio-' + idx">선택</label>
                        </div>
                        <button type="button" class="flex-box flex-between">
                          <span class="info">
                            <span class="date">{{ item.orderDt }}</span>
                            <span class="detail">
                              (주문번호:
                              <span class="system">
                                {{
                                  item.sapOrderNo == null
                                    ? item.orderNo
                                    : item.sapOrderNo
                                }}
                              </span>
                              )
                              <span class="system">{{ item.zzmaktx }}</span>

                              <span class="system" v-if="item.orderCnt > 0"
                                >외 {{ item.orderCnt }} 건</span
                              >
                            </span>
                          </span>
                          <strong class="price">
                            <span class="system">{{
                              Number(item.goodsUntprc).toLocaleString()
                            }}</span
                            >원
                          </strong>
                        </button>
                      </div>
                      <div
                        :id="'act' + idx"
                        class="accordion-content"
                        data-accordion-content
                        :aria-hidden="data.one.expendIndex !== idx"
                      >
                        <div class="order-list-box">
                          <div
                            class="item"
                            v-for="(dItem, dIndex) in item.detail"
                            :key="dIndex"
                          >
                            <div class="c-checkbox type-small">
                              <input
                                type="checkbox"
                                :id="'order-item-chkgroup' + idx + '-' + dIndex"
                                :name="'order-item-chkgroup' + dIndex"
                                :value="
                                  'order-' + idx + '-item-' + dItem.goodsSn
                                "
                                v-model="data.check.orderItemChk"
                                @change="
                                  btnCmd('orderItemChk', {
                                    order: idx,
                                    good: dItem.goodsSn,
                                    title: item,
                                    item: dItem,
                                  })
                                "
                              />
                              <label
                                :for="
                                  'order-item-chkgroup' + idx + '-' + dIndex
                                "
                                >{{ dItem.orderStatusNm }}</label
                              >
                            </div>
                            <p class="desc">
                              {{ dItem.zzmaktx }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- // D: 주문건 선택리스트 -->

                <!-- D : 데이터 없는경우 -->
                <div class="c-no-data-box" v-if="!data.one.listFlag">
                  <div class="icon-box">
                    <i class="c-icon icon-nodata size-large"></i>
                  </div>
                  <div class="text">
                    <p>
                      기간 내 주문건이 없습니다.<br />
                      주문 기간을 다시 선택해주세요.
                    </p>
                  </div>
                </div>
                <!-- // D : 데이터 없는경우 -->

                <!-- D: PC 전용 -->
                <!-- D : pageing area -->
                <Pagination
                  ref="paginationEl"
                  v-if="data.one.listFlag"
                  :total-pages="data.one.totalPage"
                  :per-page="data.one.limit"
                  :show-select="false"
                  @page-change="handlePageChange"
                  @items-per-page-change="handleItemsPerPageChange"
                />
                <!-- // D : pageing area -->
                <!-- // D: PC 전용 -->
              </div>
            </div>
          </div>

          <div class="dialog-footer">
            <div class="c-btn-area">
              <button
                type="button"
                class="c-button type-secondary"
                @click="() => emits('close')"
              >
                <span>취소</span>
              </button>
              <button
                type="button"
                class="c-button type-primary"
                @click="btnCmd('choose', {})"
              >
                <span>선택</span>
              </button>
            </div>
          </div>
        </div>
        <!-- D: dimmed -->
        <div class="dimmed"></div>
      </div>
    </template>
  </AbstractPop>
</template>
<script setup="orderSelectedPop">
import {
  onMounted,
  reactive,
  inject,
  ref,
  computed,
  defineEmits,
  watch,
} from "vue";

import Pagination from "@/components/paintpro/base/pagination.vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import * as cmUtil from "@/utils/cmUtil.js";
import { api } from "@/plugins/api";
import $ from "jquery";

const url = inject("url_prefix");
const startDatepickerRef = ref(null);
const endDatepickerRef = ref(null);
const paginationEl = ref(null);
const emits = defineEmits(["close", "choose"]);

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  one: {
    expendIndex: -1,
    list: [],
    page: 0, // 현재 페이지
    limit: 8, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    loading: false,
    listFlag: true,
  },
  search: {
    startRegDt: "",
    endRegDt: "",
  },
  check: {
    chkDate: "",
    orderChek: "",
    orderItemChk: [],
    orderIndex: -1,
    orderIndexPrev: -1,
    title: {},
    chkItem: [],
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  jqueryDatepicker(); // 달력
  dateCalculation("1M");
  pageInit(); // 초기셋팅
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await searchCmd("search");
}

const datePair = computed(() => [data.search.startRegDt, data.search.endRegDt]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (!cmUtil.validDateDiffDay(start, end, 90)) {
      data.search.startRegDt = oldStartDate;
      data.search.endRegDt = oldEndDate;
      await cmUtil.alert(
        "조회기간은 최대 3개월입니다.\n날짜를 다시 선택해주세요."
      );
      return;
    }
    if (!cmUtil.validDateDiffPlus(start, end)) {
      data.search.startRegDt = oldStartDate;
      data.search.endRegDt = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다. \n다시 확인해 주세요."
      );
      return;
    }
  }
);

/**********************
 * 버튼 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 아코디언 활성화
  if (cmd === "expendClick") {
    if (data.one.expendIndex == params.index) {
      data.one.expendIndex = -1;
    } else {
      data.one.expendIndex = params.index;
    }
  }
  // 주문 건 선택
  else if (cmd == "orderChk") {
    // 해당 주문 건의 제품만 담도록 초기화 처리
    data.check.orderItemChk = [];
    data.check.chkItem = [];

    if (data.check.orderIndexPrev == params.index) {
      data.check.orderIndex = -1;
      data.check.orderIndexPrev = -1;
      data.check.orderChek = 0;
    } else {
      for (var i in params.list) {
        let flag = "order-" + params.index + "-item-" + params.list[i].goodsSn;
        data.check.orderItemChk.push(flag);
        data.check.chkItem.push(params.list[i]);
      }
      data.check.orderIndex = params.index;
      data.check.orderIndexPrev = params.index;
    }

    // title를 먼저 담는 경우 find에서 걸려서 담아두고 나중에 선택 시 저장 할 예정
    data.check.title = params.title;
  }
  // 개별 선택
  else if (cmd == "orderItemChk") {
    //같은 주문 건에 대한 상품이 아닐 경우
    if (data.check.orderIndex != params.order) {
      // 초기화
      data.check.orderItemChk = [];
      data.check.chkItem = [];

      // 해당 상품 담기
      let flag = "order-" + params.order + "-item-" + params.good;
      data.check.orderItemChk.push(flag);
    }

    // 중복이 되지 않도록 처리
    const findGood = data.check.chkItem.find(
      (item) => item.goodsSn == params.good
    );

    if (findGood == null && findGood == undefined) {
      data.check.chkItem.push(params.item);
    } else {
      data.check.chkItem = data.check.chkItem.filter(
        (ele) => ele.goodsSn != params.good
      );
    }

    // 주문 건 index 유지
    data.check.orderIndex = params.order;
    data.check.orderChek = "";

    // title를 먼저 담는 경우 find에서 걸려서 담아두고 나중에 선택 시 저장 할 예정
    data.check.title = params.title;
  }
  // 초기화
  else if (cmd == "reset") {
    data.check.chkDate = "1M";
    await dateCalculation("1M");
  }
  // 선택한 제품 문의주문으로 보내기
  else if (cmd == "choose") {
    if (data.check.orderIndex < 0) {
      cmUtil.toast(`선택정보가 없습니다.`, { type: "basket" });
      return false;
    }
    data.check.chkItem.unshift(data.check.title);

    emits("choose", data.check.chkItem);
    emits("close");
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  if (cmd === "search") {
    const res = await api.post(`${url}/custCenter/selectCust01`, {
      startRegDt: data.search.startRegDt,
      endRegDt: data.search.endRegDt,
      page: params["page"] || 1,
      limit: params["limit"] || data.one.limit,
    });
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }
    data.one.expendIndex = -1;
    data.one.list = res.data;

    data.one.list = res.data.list;
    data.one.page = params["page"] || 1;
    data.one.totalCount = res.data.totalCount;
    data.one.totalPage = data.one.totalCount
      ? Math.ceil(data.one.totalCount / data.one.limit)
      : 0;

    if (res.data.totalCount > 0) {
      data.one.listFlag = true;
    } else {
      data.one.listFlag = false;
    }
  }
}

/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  searchCmd("search", { page: page });
}
function handleItemsPerPageChange(perPage) {
  data.one.limit = perPage;
  searchCmd("search", {});
}

/**********************
 * jquery 달력
 *********************/
async function jqueryDatepicker() {
  if (startDatepickerRef.value == null) return;
  $(startDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "-1D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.search.startRegDt = dateText;
      data.check.chkDate = "";
    },
  });

  // 종료일
  if (endDatepickerRef.value == null) return;
  $(endDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "0D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.search.endRegDt = dateText;
      data.check.chkDate = "";
    },
  });
}

/**********************
 * 등록일 버튼 모음
 *********************/
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);

  switch (period) {
    case "1W":
      resultDate.setDate(today.getDate() - 6);
      break;
    case "1M":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "3M":
      resultDate.setDate(today.getDate() - 89);
      break;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);

  data.search.startRegDt = resultDate;
  data.search.endRegDt = todayDate.value;
  data.check.chkDate = period;
}
</script>
